






















import { Component, Vue } from "vue-property-decorator";

@Component({
  props: {
    value: {
      type: String,
      default: ""
    },
    title: {
      type: String
    },
    okTitle: {
      type: String,
      default: "OK"
    },
    cancelTitle: {
      type: String,
      default: "キャンセル"
    },
    placeholder: {
      type: String
    },
    maxlength: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    }
  }
})
export default class VPrompt extends Vue {
  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  currentValue = "";
}
